import { render, staticRenderFns } from "./StreamDetailsPanel.vue?vue&type=template&id=c984edf2&scoped=true"
import script from "./StreamDetailsPanel.vue?vue&type=script&lang=js"
export * from "./StreamDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./StreamDetailsPanel.vue?vue&type=style&index=0&id=c984edf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c984edf2",
  null
  
)

export default component.exports